import { JsonConverter, JsonCustomConvert, JsonConvert, JsonObject, JsonProperty, Any } from "json2typescript";
import { BaseResponse } from "../base-response";

//region === Modello per la Visualizzazione (GET) ===
@JsonConverter
export class AccountConverter implements JsonCustomConvert<Account>{
    serialize() { }
    deserialize(data: any): Account {
        const jsonConvert: JsonConvert = new JsonConvert();
        return jsonConvert.deserializeObject(data, Account);
    }
}

@JsonConverter
export class AccountArrayConverter implements JsonCustomConvert<Array<Account>>{
    serialize() { }
    deserialize(data: any): Array<Account> {
        const jsonConvert: JsonConvert = new JsonConvert();
        return jsonConvert.deserializeArray(data, Account);
    }
}

@JsonObject("Account")
export class Account {
    @JsonProperty("uuid", String, true)
    uuid: string = "";
    @JsonProperty("tenant", String, true)
    tenant: string = "";
    @JsonProperty("username", String, true)
    username: string = "";
    @JsonProperty("permissions_group", String, true)
    permissions_group: string = "";
    @JsonProperty("permissions", [String], true)
    permissions: Array<string> = new Array<string>();
    @JsonProperty("locations_groups", [String], true) // Corretto da locations_group a locations_groups
    locations_groups: Array<string> = new Array<string>();

    // Normalizza eventuali [null] in [] dopo la deserializzazione
    constructor() {
        // ...existing code...
    }

    static normalizeLocationsGroups(account: Account) {
        if (Array.isArray(account.locations_groups)) {
            account.locations_groups = account.locations_groups.filter((id) => !!id);
        }
        return account;
    }
}
//endregion

//region === Modello per Richieste API (POST/PUT) ===
@JsonObject("AccountRequest")
export class AccountRequest {
    // Campi per la creazione e modifica
    uuid: string = ""; // Usato solo per l'update
    username: string = "";
    password: string = "";
    permission_group_name: string = "";
    locations_groups: Array<string> = new Array<string>();
    metadata: any = {};

    // Prepara il body per la creazione di un nuovo account
    dtoCreate() {
        return {
            username: this.username,
            password: this.password,
            permission_group_name: this.permission_group_name,
            locations_groups: this.locations_groups,
            metadata: this.metadata,
        };
    }

    // Prepara il body per la modifica di un account esistente
    dtoUpdate() {
        return {
            uuid: this.uuid,
            permission_group_name: this.permission_group_name,
            locations_groups: this.locations_groups,
            metadata: this.metadata,
        };
    }
}
//endregion

//region === Wrapper per la Risposta GET ===
@JsonObject("AccountListCount")
export class AccountListCount {
    @JsonProperty("count", Number, true)
    count: number = 0;
    @JsonProperty("data", AccountArrayConverter, true)
    data: Array<Account> = new Array<Account>();
}
@JsonObject("AccountListData")
export class AccountListData extends BaseResponse {
    @JsonProperty("data", AccountListCount, true)
    data: AccountListCount = new AccountListCount;
}
//endregion